import { IMonthSelectOption } from '../interfaces/IMonthSelectOption';

export const monthSelectOptions: IMonthSelectOption[] = [
  {
    id: 1,
    label: 'Январь',
    value: 1,
  },
  {
    id: 2,
    label: 'Февраль',
    value: 2,
  },
  {
    id: 3,
    label: 'Март',
    value: 3,
  },
  {
    id: 4,
    label: 'Апрель',
    value: 4,
  },
  {
    id: 5,
    label: 'Май',
    value: 5,
  },
  {
    id: 6,
    label: 'Июнь',
    value: 6,
  },
  {
    id: 7,
    label: 'Июль',
    value: 7,
  },
  {
    id: 8,
    label: 'Август',
    value: 8,
  },
  {
    id: 9,
    label: 'Сентябрь',
    value: 9,
  },
  {
    id: 10,
    label: 'Октябрь',
    value: 10,
  },
  {
    id: 11,
    label: 'Ноябрь',
    value: 11,
  },
  {
    id: 12,
    label: 'Декабрь',
    value: 12,
  },
];
